




























































import Vue from 'vue';
import { PropType } from '../../../models/CustomerProp';
import customerClient from '../../../apis';

export default Vue.extend({
  props: {
    customer: {
      type: Object,
      default: {},
    },
    prop: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showEdit: false,
      loading: false,
      PropType,
      value: null,
      dateValue: null,
    };
  },
  watch: {
    value() {
      if (this.prop.propType === PropType.Numeric) {
        this.value = this.value.toString().replace(/[^\d.]/g, '');
      }
    },
  },
  computed: {
    realValue(): any {
      if (this.prop.propType === PropType.LocalDate) {
        return this.dateValue;
      } else if (this.prop.propType === PropType.DateTime) {
        return this.dateValue + ':00';
      } else {
        return this.value;
      }
    },
    displayField(): any {
      if (this.prop.builtIn) {
        const str = this.customer[this.prop.fieldName];
        if (this.prop.propType === PropType.Enum) {
          const k = Object.keys(this.prop.enumValue).find((k: string) => {
            return this.prop.enumValue[k] === str;
          });
          if (k) {
            return k;
          }
        }
        if (this.prop.propType === PropType.Numeric) {
          return this.customer[this.prop.fieldName + '_original'] ? this.customer[this.prop.fieldName + '_original'] : this.customer[this.prop.fieldName];
        }
        if (this.prop.fieldName === 'sex') {
          return '未知';
        }
        return str;
      } else {
        if (this.prop.propType === PropType.Numeric) {
          return this.customer.privateProps[this.prop.fieldName + '_original'] ? this.customer.privateProps[this.prop.fieldName + '_original'] : this.customer.privateProps[this.prop.fieldName];
        } else {
          return this.customer.privateProps[this.prop.fieldName];
        }
      }
    },
  },
  methods: {
    confirmUpdate() {
      this.loading = true;
      customerClient.updateProp({
        openid: this.customer.openid,
        fieldName: this.prop.fieldName,
        value: this.realValue,
      })
        .success(() => {
          this.$Message.success('修改成功');
          this.showEdit = false;
          if (!this.prop.builtIn && !this.customer.privateProps[this.prop.fieldName]) {
            setTimeout(() => {
              this.$store.commit('CUSTOMER_TABLE_REFRESH');
            }, 1000);
          }
          if (this.prop.propType === PropType.Numeric) {
            this.$store.commit('UPDATE_CUSTOMER_PROP', {
              openid: this.customer.openid,
              key: this.prop.fieldName + '_original',
              value: this.realValue,
              builtIn: this.prop.builtIn,
            });
          } else {
            this.$store.commit('UPDATE_CUSTOMER_PROP', {
              openid: this.customer.openid,
              key: this.prop.fieldName,
              value: this.realValue,
              builtIn: this.prop.builtIn,
            });
          }
        }).failure((code: string, msg?: string) => {
          this.$Message.error(msg);
        }).error((e) => {
          this.$Message.error(e.toString());
        }).done(() => {
          this.loading = false;
        });
    },
    updateDateValue(date: string) {
      this.dateValue = date;
    },
  },
  mounted() {
    if (this.prop.builtIn) {
      this.value = this.customer[this.prop.fieldName + '_original'] ? this.customer[this.prop.fieldName + '_original'] : this.customer[this.prop.fieldName];
    } else {
      this.value = this.customer.privateProps[this.prop.fieldName + '_original'] ? this.customer.privateProps[this.prop.fieldName + '_original'] : this.customer.privateProps[this.prop.fieldName];
    }
    if (this.prop.propType === PropType.LocalDate ||
        this.prop.propType === PropType.DateTime) {
      this.dateValue = this.value;
    }
    if (!this.value && this.prop.propType === PropType.Numeric) {
      this.value = 0;
    }
  },
});
